import {
  SlInput
} from "./chunk.4RFB4FGM.js";

// src/components/input/input.ts
var input_default = SlInput;
SlInput.define("sl-input");

export {
  input_default
};
